import { render, staticRenderFns } from "./printOwnerVotingList.vue?vue&type=template&id=7051a0a0&scoped=true"
import script from "./printOwnerVotingList.vue?vue&type=script&lang=js"
export * from "./printOwnerVotingList.vue?vue&type=script&lang=js"
import style0 from "./printOwnerVotingList.vue?vue&type=style&index=0&id=7051a0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051a0a0",
  null
  
)

export default component.exports